import script from "./BlockAttributesListing.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockAttributesListing.vue?vue&type=script&setup=true&lang=js"

import "./BlockAttributesListing.vue?vue&type=style&index=0&id=6bfb9e05&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bfb9e05"]])

export default __exports__